var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTestopsBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "86px",
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get-Started",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-581.000000, -230.000000)",
    id: "logo-testops-welcome"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(581.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-43",
    fill: "#5CCEFF",
    points: "2.44426701e-12 86 43 86 42.9928353 68.8094744 86 0 2.44426701e-12 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-33",
    fill: "#4D94FF",
    transform: "translate(53.000000, 57.500000) scale(-1, 1) translate(-53.000000, -57.500000) ",
    points: "20 86 68.0014283 86 86 57.0023277 55.5390618 29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2631579,22 L43.6876463,22 C48.0139515,22 52.1630625,23.718618 55.2222222,26.7777778 C58.281382,29.8369375 60,33.9860485 60,38.3123537 L60,62.7368421 C60,63.9867497 58.9867497,65 57.7368421,65 L33.3123537,65 C28.9860485,65 24.8369375,63.281382 21.7777778,60.2222222 C18.718618,57.1630625 17,53.0139515 17,48.6876463 L17,24.2631579 C17,23.0132503 18.0132503,22 19.2631579,22 Z",
    id: "Rectangle-Copy-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "To",
    fill: "#4D94FF",
    fillRule: "nonzero",
    points: "28 30 49 30 49 36.3142857 41.9396552 36.3142857 41.9396552 56 35.0603448 56 35.0603448 36.3142857 28 36.3142857"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTestopsBig);
export default __webpack_public_path__ + "static/media/logo_testops_big.6c1d81888579fe1721613a449e3004a2.svg";
export { ForwardRef as ReactComponent };